import React from 'react';
import {
  type PageTemplate,
  PrudsysBasketProductsRecoSlider,
  SearchBasketToProductsRecoSlider,
  SearchTopsellerProductsRecoSlider,
} from '@packages/recommendations';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  productRecSliderHeadline: {
    id: 'CheckoutContainer.Basket.ProductRec.Headline',
    defaultMessage: 'Empfehlungen für Sie',
  },
});

const providerComponentMap = {
  empiriecom: {
    empty: SearchTopsellerProductsRecoSlider,
    filled: SearchBasketToProductsRecoSlider,
  },
  prudsys: {
    empty: PrudsysBasketProductsRecoSlider,
    filled: PrudsysBasketProductsRecoSlider,
  },
};

export const BasketWishlistRecommendation = ({
  pageTemplate,
  productIds,
  aklIds,
}: {
  pageTemplate: PageTemplate;
  productIds: string[];
  aklIds: string[];
}) => {
  const { formatMessage } = useIntl();
  const {
    recommendations: { provider },
  } = useConfig();

  const RecoSlider = providerComponentMap[provider][aklIds.length ? 'filled' : 'empty'];
  return (
    <RecoSlider
      pageTemplate={pageTemplate}
      preferTitle
      title={formatMessage(messages.productRecSliderHeadline)}
      fetchOnThreshold
      productIds={productIds}
      aklIds={aklIds}
      elementIndex={0}
    />
  );
};
